// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../Header/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../../../../public/lamp.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../../../../public/AJS_1738.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Parisienne);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Playfair);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Merienda);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Edu+AU+VIC+WA+NT+Hand);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playwrite+GB+S:ital);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1, h2, h4, p {
    /* font-family: "Playwrite GB S", cursive; */
    font-family: "Edu AU VIC WA NT Hand", cursive;
	color: black;
}

p {
    font-size: 1.5rem;
}

.details {
	font-family: 'parisienne';
	font-size: 2rem;
    font-weight: bold;
}

.names {
	font-family: 'parisienne';
	margin-top: 18vh;
	font-size: 6rem;
}

.myDiv {
    position: relative;
    z-index: 1;
    height: 100vh;
}

@media all and (max-width: 800px) {
    .myDiv .bg {
        /* put your css styles in here */
        position: absolute;
        z-index: -1;
        top: 0;
        background-size: cover;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: .5;
        width: 100%;
        height: 100%;
  }
}

@media all and (min-width: 800px) {
    .myDiv .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
        background-repeat: no-repeat;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: .5;
        width: 100%;
        height: 100%;
    }
}

* {
  margin:0;
  padding:0px;
  background-size: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App/pages/Home/styles.css"],"names":[],"mappings":"AAQA;IACI,4CAA4C;IAC5C,6CAA6C;CAChD,YAAY;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;CACC,yBAAyB;CACzB,eAAe;IACZ,iBAAiB;AACrB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI;QACI,gCAAgC;QAChC,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,sBAAsB;QACtB,yDAAsD;QACtD,4BAA4B;QAC5B,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,WAAW;QACX,YAAY;EAClB;AACF;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,MAAM;QACN,yDAA0D;QAC1D,4BAA4B;QAC5B,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,qBAAqB;AACvB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Parisienne');\n@import url('https://fonts.googleapis.com/css?family=Playfair');\n@import url('https://fonts.googleapis.com/css?family=Merienda');\n@import url('https://fonts.googleapis.com/css2?family=Edu+AU+VIC+WA+NT+Hand');\n@import url('https://fonts.googleapis.com/css2?family=Playwrite+GB+S:ital');\n\n@import '../Header/styles.css';\n\nh1, h2, h4, p {\n    /* font-family: \"Playwrite GB S\", cursive; */\n    font-family: \"Edu AU VIC WA NT Hand\", cursive;\n\tcolor: black;\n}\n\np {\n    font-size: 1.5rem;\n}\n\n.details {\n\tfont-family: 'parisienne';\n\tfont-size: 2rem;\n    font-weight: bold;\n}\n\n.names {\n\tfont-family: 'parisienne';\n\tmargin-top: 18vh;\n\tfont-size: 6rem;\n}\n\n.myDiv {\n    position: relative;\n    z-index: 1;\n    height: 100vh;\n}\n\n@media all and (max-width: 800px) {\n    .myDiv .bg {\n        /* put your css styles in here */\n        position: absolute;\n        z-index: -1;\n        top: 0;\n        background-size: cover;\n        background-image: url('./../../../../public/lamp.jpg');\n        background-repeat: no-repeat;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        opacity: .5;\n        width: 100%;\n        height: 100%;\n  }\n}\n\n@media all and (min-width: 800px) {\n    .myDiv .bg {\n        position: absolute;\n        z-index: -1;\n        top: 0;\n        background-image: url('./../../../../public/AJS_1738.jpg');\n        background-repeat: no-repeat;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        opacity: .5;\n        width: 100%;\n        height: 100%;\n    }\n}\n\n* {\n  margin:0;\n  padding:0px;\n  background-size: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
